<script>
export let currentRoute;


import Rink from 'components/views/my/covid/elements/Rink.svelte';
// import City from 'components/views/my/covid/elements/City.svelte';
import Loading from 'components/elements/Loading.svelte';
// import Error from 'components/elements/Error.svelte';



import { auth } from 'store/index.js';


import { get } from 'svelte/store';
import SvelteSeo from 'svelte-seo';



const api_url = app_.env.API_URL;



const token = get(auth).token;



// get last regit


const ns_cities = [
	{
		name: 'Halifax/HRM',
		rinks: [
			{
				name: 'BMO',
				rules: [
					'Arrival Time: 15 Min before / after',
					'Spectators: 50 spectators in A/B/C + 100 spectators in D. Spectators allowed to enter 5 mins before and must leave within 10 minutes after.',
					'Contact Tracing by Team Rep',
				],
			},
			{
				name: 'Civic/Forum',
				rules: [
					'Arrival Time: 15 Mins before / 25 Mins after. Spectators only allowed 5 minutes before.',
					'Spectators: 100 in Forum, 75 in Civic.',
					'Contact Tracing by Team Rep',
				],
			},
			{
				name: 'Cole Harbour Place',
				rules: [
					'Arrival Time: 15 min before and after.',
					'Spectators: 85 in Scotia 1, 35 in Scotia 2.',
				],
			},
			{
				name: 'RBC',
				rules: [
					'Arrival Time: 15 mins before / after. Spectators allowed to enter 5 minutes before and leave 10 minutes after. ',
					'Spectators: 50 in A/B/D - 100 in C.',
				],
			},
		],
	},
	{
		name: 'Acadia',
		rinks: [
			{
				name: 'Andrew H. McCain Arena',
				rules: [
					'Arrival Time: 15 min before / after. Spectators allowed 5 min before and leave 5 min after.',
					'Spectators: 1 per player.',
					'Team Rep must present to front desk upon arrival. ',
				],
			},
		],
	},
	{
		name: 'Amherst',
		rinks: [
			{
				name: 'Amherst Stadium',
				rules: [
					'Arrival Time: 15 mins before / after. Spectators allowed 5 min before.',
					'Spectators: Maximum of 100 permitted.',
					'Safety rep must be first into building and conduct contact tracing.',
				],
			},
		],
	},
	{
		name: 'Bridgewater',
		rinks: [
			{
				name: 'Lunenberg County Lifestyle Centre',
				rules: [
					'Arrival Time: 20 mins before / after',
					'Spectators: No more than 3 per player',
					'Contact Tracing by Team Rep',
				],
			},
		],
	},
	{
		name: 'Liverpool',
		rinks: [
			{
				name: `Queen's Place Emera Centre`,
				rules: [
					'Arrival Time: 20 mins before / after',
					'Spectators: No more than 3 per player',
				],
			},
		],
	},
	{
		name: 'Pictou County',
		rinks: [
			{
				name: `Pictou County Wellness Centre`,
				rules: [
					'Arrival Time: 30 min. Spectators 5 min before.',
					'Spectators: 2 spectators per player.',
					'Contact Tracing by Team Rep',
				],
			},
		],
	},
	{
		name: 'Port Hawkesbury',
		rinks: [
			{
				name: `P.H. Civic Centre`,
				rules: [
					'Arrival Time: 30 Minutes before and 15 minutes after. Spectators are 5 minutes before and after.',
					'Spectators: 2 per player',
				],
			},
		],
	},
	{
		name: 'Sydney',
		rinks: [
			{
				name: `Membertou`,
				rules: [
					'Practice Arrival Time: 20 mins before / 15 after.',
					'Game Arrival Time: 30 mins before / 20 after.',
					'Spectators: 100 in Emera, 78 in BMO. Spectators can enter 10 min before.',
					'Contact Tracing by Team Rep',
				],
			},
		],
	},
	{
		name: 'Truro',
		rinks: [
			{
				name: `Rath Eastlink Community Centre`,
				rules: [
					'Arrival Time: 15 Minutes before and after. Spectators are 5 minutes before and after. ',
					'Spectators: 100 maximum.',
					'Contact Tracing by Team Rep + Front Desk Sign In',
				],
			},
			{
				name: 'Colchester Stadium',
				rules: [
					'Arrival Time: 20 Minutes before and after. Spectators are 10 minutes before and after.',
					'Spectators: 100 Maximum',
					'Contact Tracing by Team Rep',
				],
			},
		],
	},
	{
		name: 'Yarmouth',
		rinks: [
			{
				name: `Mariners Centre`,
				rules: [
					'Mariners Centre',
					'Spectators: 100 in Arena 1, 70 in Arena 2',
					'Contact Tracing Required by Team Rep',
				],
			},
		],
	},
];


const nb_cities = [
	{
		name: 'Bouctouche',
		rinks: [
			{
				name: 'JKI Centre',
				rules: [
					'Arrival Time: 30 min before for goalies, safety rep, and 1 coach. 20 mins before for others. All must leave 15 minutes after.',
					'Spectators: 2 adults per player + sibling that cannot stay at home alone.',
					'Contact Tracing by Team Rep',
				],
			},
		],
	},
	{
		name: 'Fredericton',
		rinks: [
			{
				name: 'Grant-Harvey',
				rules: [
					'Arrival Time: 15 Minutes before and after',
					'Spectators: 2 per player',
					'Contact Tracing by Team Rep',
				],
			},
		],
	},
	{
		name: 'Miramichi',
		rinks: [
			{
				name: 'Sunny Corner',
				rules: [
					'Arrival Time: 15 Minutes before and after',
					'Spectators: 2 per player',
					'Contact Tracing by Team Rep',
				],
			},
		],
	},
	{
		name: 'Memramcook',
		rinks: [
			{
				name: 'Arena Eugene LeBlanc',
				rules: [
					'Arrival Time: 25 mins for players, coaches, managers, and covid rep. 15 minutes for parents/spectators. 15 minutes after for all participants.',
					'Spectators: 2 spectators per player.',
					'Contact Tracing by Team Rep',
				],
			},
		],
	},
	{
		name: 'Moncton',
		rinks: [
			{
				name: 'Superior Propane Centre',
				rules: [
					'Arrival Time: 30 mins before / 15 mins after',
					'Spectators: 3 family members per skater. Need to sign in at front.',
				],
			},
			{
				name: 'Avenir',
				rules: [
					'Arrival Time: 30 minutes before/after',
					'Spectators: 3 family members per player.',
				],
			},
		],
	},
	{
		name: 'Saint John',
		rinks: [
			{
				name: 'Q-Plex',
				rules: [
					'Arrival time: 30 min',
					'Spectators: 2 per player',
					'Contact Tracing by Team Rep',
				],
			},
			{
				name: 'Rothesay Netherwood',
				rules: [
					'Arrival time: 15 min',
					'Spectators: 1 per player',
					'Contact Tracing by Team Rep',
				],
			},
			{
				name: 'Stu Hurley',
				rules: [
					'Arrival time: 30 min',
					'Spectators: 1 per player',
					'Contact Tracing by Team Rep',
				],
			},
		],
	},
	{
		name: 'Tracadie',
		rinks: [
			{
				name: 'Arena S.A. Dionne',
				rules: [
					'Arrival Time: 25 min before and after.',
					'Spectators: 2 per player',
					'Contact Tracing by Team Rep',
				],
			},
		],
	},
];


const pei_cities = [
	{
		name: 'Summerside',
		rinks: [
			{
				name: 'Credit Union Place',
				rules: [
					'Arrival Time: 20 min before / 15 min after',
					'Spectators: 50 Maximum',
					'Contact Tracing by Team Rep',
				],
			},
		],
	},
	{
		name: 'Pownal',
		rinks: [
			{
				name: 'Pownal Sports Centre',
				rules: [
					'TBA',
				],
			},
		],
	},
];



</script>


<style>

.hero {
	margin-bottom: 1rem;
}

.province-section {
	/*margin-bottom: 1.5rem;*/
	padding-top: 2rem;
	padding-bottom: 2rem;
}

.province-title {
	margin-bottom: 2.5rem;
	font-size: 1.675rem;
	font-weight: 400;
	text-decoration: underline;
	color: var(--text-dark);
}

</style>


<SvelteSeo
	title='Covid Rules | AHG Coaches Portal'
	description='Covid Rules | AHG Coaches Portal'
/>


<section class="hero bg-grey">

	<div class="hero-body">

		<div class="container">

			<p class="hero-subtitle has-text-centered">
				Covid Rules for Spring Facilities
			</p>

			<p class="hero-undertitle has-text-centered" style="color: #b2b2b2; margin-top: 0.75rem; font-size: 1.05rem; max-width: 60%; display: block; margin: 0 auto; margin-top: 0.75rem;">
				Please reference this page for information regarding Covid-related rules for all our spring facilities. While some facilities use passive tracing and others use active tracing we recommend team managers keep a paper copy of their roster on hand for contact tracing purposes. Masks must be worn by spectators in all facilities.<br><br>For ALL rinks that do NOT specify a specific spectator-per-player limit or guideline, Atlantic Hockey Group is instituting a guideline of maximum 2 spectators per player. We feel this is a fair number for rinks that have not instituted a strict spectator limit.<br><br>Please note this is not an exhaustive list of all rules for all facilities but is used as a guide to assist in planning when travelling to use different facilities this spring. 
			</p>

		</div>

	</div>

</section>



<section class="section province-section">

	<div class="container">

		<div class="columns is-centered">

			<div class="column is-11-desktop is-12-touch">

				<p class="province-title">
					Nova Scotia
				</p>

				<div class="columns is-variable is-6 is-multiline is-centered-">

					{#each ns_cities as city}

						{#each city.rinks as rink}

							<div class="column is-4-desktop is-6-tablet is-12-mobile">

								<Rink {rink} {city} />

							</div>

						{/each}

					{/each}

				</div>

			</div>

		</div>

	</div>

</section>



<section class="section province-section">

	<div class="container">

		<div class="columns is-centered">

			<div class="column is-11-desktop is-12-touch">

				<p class="province-title">
					New Brunswick
				</p>

				<div class="columns is-variable is-6 is-multiline is-centered-">

					{#each nb_cities as city}

						{#each city.rinks as rink}

							<div class="column is-4-desktop is-6-tablet is-12-mobile">

								<Rink {rink} {city} />

							</div>

						{/each}

					{/each}

				</div>

			</div>

		</div>

	</div>

</section>




<section class="section province-section">

	<div class="container">

		<div class="columns is-centered">

			<div class="column is-11-desktop is-12-touch">

				<p class="province-title">
					Prince Edward Island
				</p>

				<div class="columns is-variable is-6 is-multiline is-centered-">

					{#each pei_cities as city}

						{#each city.rinks as rink}

							<div class="column is-4-desktop is-6-tablet is-12-mobile">

								<Rink {rink} {city} />

							</div>

						{/each}

					{/each}

				</div>

			</div>

		</div>

	</div>

</section>


<br><br><br>



